exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-562e70d2], .fade-leave-active[data-v-562e70d2] {\n  -webkit-transition: opacity .5s;\n  transition: opacity .5s;\n}\n.fade-enter[data-v-562e70d2], .fade-leave-to[data-v-562e70d2] /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0;\n}", "", {"version":3,"sources":["/home/ec2-user/workspace/l-app_feature_exposure-dashboard/src/assets/stylesheet/transitions.css"],"names":[],"mappings":";AAAA;EACE,gCAAwB;EAAxB,wBAAwB;CACzB;AACD;EACE,WAAW;CACZ","file":"transitions.css","sourcesContent":[".fade-enter-active, .fade-leave-active {\n  transition: opacity .5s;\n}\n.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-562e70d2","scoped":true,"hasInlineConfig":false}!./src/assets/stylesheet/transitions.css
// module id = S8r+
// module chunks = 1